import pptxgen from 'pptxgenjs';
import { Presentation } from '..';

export const presentationToFile = (presentation: Presentation) => {
  const pptx = new pptxgen();

  if (presentation.layout) {
    pptx.defineLayout(presentation.layout);
    pptx.layout = presentation.layout.name;
  }

  if (presentation.theme) {
    pptx.theme = presentation.theme;
  }

  if (presentation.slideMasters) {
    presentation.slideMasters.forEach(slideMaster => {
      pptx.defineSlideMaster(slideMaster);
    });
  }

  if (presentation.slides) {
    presentation.slides.forEach(slideInterface => {
      const slide = pptx.addSlide({ masterName: slideInterface.slideMaster });

      if (slideInterface.color) {
        slide.color = slideInterface.color;
      }

      if (slideInterface.background) {
        slide.background = slideInterface.background;
      }

      slideInterface.shapes?.forEach(shape => {
        slide.addShape(shape.shapeName, shape.options);
      });

      slideInterface.images?.forEach(image => {
        slide.addImage(image);
      });

      slideInterface.texts?.forEach(text => {
        slide.addText(text.text, text.options);
      });

      slideInterface.tables?.forEach(table => {
        slide.addTable(table.tableRows, table.options);
      });

      slideInterface.charts?.forEach(chart => {
        slide.addChart(chart.type, chart.data, chart.options);
      });
    });

    return pptx.writeFile({
      fileName: presentation.filename,
    });
  }
};
